import { RawValdrConstraints, ValdrValidators } from '@app/valdr/models';
import { Action } from '@ngrx/store';

export enum ValdrActionTypes {
  AddValdrConstraints = '[Valdr] Add Valdr RawValdrConstraints',
  AddValdrValidators = '[Valdr] Add Valdr Validators'
}

export class AddValdrConstraints implements Action {
  readonly type = ValdrActionTypes.AddValdrConstraints;
  constructor(public payload: RawValdrConstraints) {}
}

export class AddValdrValidators implements Action {
  readonly type = ValdrActionTypes.AddValdrValidators;
  constructor(public payload: ValdrValidators) {}
}

export type ValdrActions =
  | AddValdrConstraints
  | AddValdrValidators;
